import React, { Component } from "react";
import { withRouterUtilities } from "../util/withRouterUtilities";
import CenteredPaper from "../layouts/CenteredPaper";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import ChoiceButtons from "../molecules/ChoiceButtons";
import Titles from "../molecules/Titles";
import UswfList from "../molecules/UswfList";
import ILearn from "../molecules/ILearn";

class PreapprovalIsItRightTimePage extends Component {
  render() {
    const content = contentMap.PreapprovalIsItRightTimePage;
    const navigationsAway = customNavigationMap.PreapprovalIsItRightTimePage;

    return (
      <div className="page-wrapper">
        <ILearn content={content}>
          <CenteredPaper>
            <Titles content={content} />
            <UswfList content={content} />
            <ChoiceButtons
              content={content}
              navigationsAway={navigationsAway}
              navigate={this.props.navigate}
            />
          </CenteredPaper>
        </ILearn>
      </div>
    );
  }
}

export default withRouterUtilities(PreapprovalIsItRightTimePage);
